module.exports = __webpack_public_path__ + "img/172.2f093571.jpg";